import service from "./service";

const getNotifications = ({ page = 1, limit = 10, type, status } = {}) => {
  const query = new URLSearchParams({ page: String(page), limit: String(limit) });
  if (type !== undefined && type !== null && type !== "") {
    query.set("type", String(type));
  }
  if (status && status !== "all") {
    query.set("status", String(status).toLowerCase());
  }
  return service.get(`vendors/notifications?${query.toString()}`);
};

const getUnreadCount = () => service.get("vendors/notifications/count");
const markNotificationRead = (id) =>
  service.put(`vendors/notifications/${encodeURIComponent(id)}/read`, {});

const notificationService = {
  getNotifications,
  getUnreadCount,
  markNotificationRead,
};
export default notificationService;
